import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { t } from "i18next";
import genRequest from "includes/request";
import PasswordInput from "components/Inputs/PasswordInput";
import Button from "components/Button/Button";
import LoadCont from "components/LoadCont/LoadCont";
import ErrorsCont from "components/ErrorsCont/ErrorsCont";
import "../LoginPage.css";
import "../LoginForm/LoginForm.css";
import "./DefinePassword.css";

export default function DefinePasswordPage() {
	const { token } = useParams();
	const [isValidating, setIsValidating] = useState(true);
	const [isTokenValid, setIsTokenValid] = useState(false);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [isSuccess, setIsSuccess] = useState(false);
	const [Password, setPassword] = useState("");
	const [PasswordConfirm, setPasswordConfirm] = useState("");
	const [Error, setError] = useState(false);


	useEffect(() => {
		if (!token) {
			setIsValidating(false);
			return;
		}
		genRequest("Account/IsInitUserPasswordTokenExists/" + token, null, "get"
		).then(() => {
			setIsTokenValid(true);
			setIsValidating(false);
		}).catch(() => {
			setIsTokenValid(false);
			setIsValidating(false);
		});
	}, [token]);

	function validatePassword(password) {
		if (!/[A-Z]/.test(password))
			return t("DefinePassword.ERROR_NO_UPPERCASE");
		if (!/[0-9]/.test(password))
			return t("DefinePassword.ERROR_NO_NUMBER");
		if (!/[^A-Za-z0-9]/.test(password))
			return t("DefinePassword.ERROR_NO_SPECIAL");
		return null;
	}

	function handleSubmit(e) {
		e.preventDefault();
		setError(false);

		if (!Password || !PasswordConfirm)
			return setError(t("DefinePassword.ERROR_EMPTY"));

		const validationError = validatePassword(Password);
		if (validationError)
			return setError(validationError);

		if (Password !== PasswordConfirm)
			return setError(t("DefinePassword.ERROR_NO_MATCH"));

		setIsSubmitting(true);
		genRequest(
			"Account/InitUserPasswordWithToken",
			{ Token: token, Password },
			"post"
		).then(() => {
			setIsSuccess(true);
			setIsSubmitting(false);
			setTimeout(() => {
				window.location.assign("/");
			}, 2000);
		}).catch((e) => {
			setIsSubmitting(false);
			const message = e.response?.data?.Message;
			setError(message || t("DefinePassword.ERROR_SUBMIT"));
		});
	}

	function renderContent() {
		if (isValidating)
			return <LoadCont />;

		if (!isTokenValid)
			return (
				<div className="text-center">
					<div className="mb-3">{t("DefinePassword.TOKEN_EXPIRED")}</div>
					<Button className="btn-conn" onClick={() => window.location.assign("/")}>
						{t("Login.BACK_HOME")}
					</Button>
				</div>
			);

		if (isSuccess)
			return (
				<div className="text-center">
					<div className="mb-3">{t("DefinePassword.SUCCESS")}</div>
					<Button className="btn-conn" onClick={() => window.location.assign("/")}>
						{t("Login.BACK_HOME")}
					</Button>
				</div>
			);

		if (isSubmitting)
			return <LoadCont />;

		return (
			<form onSubmit={handleSubmit}>
				<div className="mb-2 text-center">{t("DefinePassword.TITLE")}</div>
				<div className="inputs-wrapper">
					<label className="d-flex align-items-center mb-1 login-input">
						<PasswordInput
							className="w-100"
							placeholder={t("DefinePassword.NEW_PASSWORD")}
							value={Password}
							onChange={setPassword}
							autoFocus
						/>
					</label>
					<label className="d-flex align-items-center login-input">
						<PasswordInput
							className="w-100"
							placeholder={t("DefinePassword.CONFIRM_PASSWORD")}
							value={PasswordConfirm}
							onChange={setPasswordConfirm}
						/>
					</label>
				</div>
				<ErrorsCont className="mt-3" errors={Error} listed={false} />
				<div className="d-flex align-items-center mt-3">
					<Button className="btn-conn" type="submit">
						{t("DefinePassword.SUBMIT")}
					</Button>
				</div>
			</form>
		);
	}

	return (
		<div className="LoginPage LoginForm DefinePasswordPage">
			<div className="login-wrapper">
				<div className="logo-cont"></div>
				{renderContent()}
			</div>
		</div>
	);
}
